export const PROGRESSIVE_DISCLOSURE_FORM_V2 = {
  id: 'FcDaUCI2SumJruOlulOytA',
  name: 'Form with progressive disclosure v2 behavior',
  variants: ['1', '2'],
  emailsFieldsForm: '1',
  emailFieldConfirmationStepForm: '2',
};

export const PROGRESSIVE_DISCLOSURE_FORM_V2_MGM = {
  id: '_K7PIS-JQLKZO-BZGTfcWg',
  name: 'Form with progressive disclosure v2 behavior - MGM',
  variants: ['1', '2'],
  emailsFieldsForm: '1',
  emailFieldConfirmationStepForm: '2',
};

export const SHORT_TIME_EXPERIMENT = {
  id: '3oOVgAXtRqmrwOMnplRhRQ',
  name: 'Short-time answer on /cartao',
  variants: ['1'],
  shortTimeAnswer: '1',
};

export const PAID_MKT_NEW_COPYS = {
  id: 'Cy6JXicQQKSAKWFIZh2k0A',
  name: 'New Copys for MKT Landing Page Hero',
  variants: ['1', '2', '3'],
  ecosystem: '1',
  price: '2',
  shortTime: '3',
};

